import CMSWrapper from '@/features/shared/CMSWrapper';
import ContentContainer from '@/features/shared/ContentContainer';
import { MuiContainer } from '@/features/shared/material-ui';
import { ColorNames, SpacingSizes } from '@/utils/constants';
import { resolveBool } from '@/utils/resolvers';
import React, { useRef } from 'react';
import PowerApps from './PowerApps';

const PowerAppsMapper = ({ srcUrl, showResizeButton = true, presentation = {} }: any) => {
  return (
    <ContentContainer
      topSpacing={SpacingSizes.small}
      bottomSpacing={SpacingSizes.small}
      topBackgroundColor={ColorNames.charcoal}
      bottomBackgroundColor={ColorNames.charcoal}
      datalayerPosition="power_apps"
      datalayerVariant={presentation?.datalayerVariant}
    >
      <MuiContainer>
        <PowerApps srcUrl={srcUrl} showResizeButton={showResizeButton} title={srcUrl} />
      </MuiContainer>
    </ContentContainer>
  );
};

const PowerAppsCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    'powerapps-url': 'srcUrl',
    'include-sizing': ['showResizeButton', resolveBool],
    componentParameterMap: [
      'presentation',
      {
        'variant-label': 'datalayerVariant',
      },
    ],
  });

  const requiredFields = useRef({
    'powerapps-url': '<b>powerAppsUrl value is required</b>',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={PowerAppsMapper}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
    />
  );
};

export default PowerAppsCMSWrapper;
